
export const zfill = (v, n, str) => {
  if (String(v).length > n) {
    return String(v)
  } else {
    return Array(n - String(v).length + 1).join(str || '0') + v
  }
}

export const formatMs = (input, full) => {
  if (input || input === 0) {
    let ms = parseInt(input, 10)
    let signo = ''
    if (ms < 0) {
      // signo = '-'
      return '---'
    }
    ms = Math.abs(ms)

    let s = Math.floor(ms / 1000)
    let m = Math.floor(s / 60)
    let h = Math.floor(m / 60)
    s = s % 60
    m = m % 60

    ms = ms % 1000
    if (typeof full === 'undefined' || !full) {
      // redondeamos o segundo superior
      if (ms) {
        s++
      }

      if (s === 60) {
        m += 1
        s = 0
      }
      if (m === 60) {
        h += 1
        m = 0
      }

      return signo + zfill(h, 2) + ':' + zfill(m, 2) + ':' + zfill(s, 2)
    } else {
      return signo + zfill(h, 2) + ':' + zfill(m, 2) + ':' + zfill(s, 2) + '.' + zfill(ms, 3)
    }
  }
  return ''
}

export const formatMsShort = (input, full) => {
  const v = formatMs(input, full)
  if (v.startsWith('00:')) {
    return v.substr(3)
  }
  return ''
}

export const msAhora = () => {
  const d = new Date()
  const offset = d.getTimezoneOffset()
  let ms = d.getMilliseconds() +
    1000 * (d.getSeconds() + 60 * (d.getMinutes() + 60 * d.getHours()))
  // 60 e o Timezone Offset do guntime
  // alert(ms)
  // alert(offset)
  return ms + offset - 60
}

/**
 * Ms pero no desde el inicio del día: desde el inicio del día de la carrera.
 *
 * @param fecha_inicio string formato 'yyyy-mm-dd'
 */
export const msFullAhora = (fechaInicio) => {
  const d = new Date()
  // const offset = d.getTimezoneOffset()
  const ms = d.getMilliseconds() + 1000 * (d.getSeconds() + 60 * (d.getMinutes() + 60 * d.getHours()))

  const di = new Date(fechaInicio)
  // ojito: En safari as fechas teñen que ir con /, se non nada...
  const mes = (d.getMonth() + 1).toString()
  const dia = d.getDate().toString()
  const mesFormatted = mes.length === 1 ? '0' + mes : mes
  const diaFormatted = dia.length === 1 ? '0' + dia : dia
  const df = new Date(d.getFullYear() + '-' + mesFormatted + '-' + diaFormatted)
  // alert(d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate())
  return df - di + ms
}

export function getControlById(controles, id) {
  let c = controles.filter(o => parseInt(o.id, 10) === parseInt(id, 10))
  if (c && c.length) {
    return c[0]
  }
  return null
}

export const getPrevisionInicioDistancia = (competicion, controles) => {
  if (competicion.prevision_control_iniciar) {
    const inicioPrevision = getControlById(controles, competicion.prevision_control_iniciar)
    if (inicioPrevision) {
      return inicioPrevision.distancia
    }
  }
  return 0
}

export const calculaPrevision = (competicion, controles, sectores, resultado, controlPrevision) => {
  try {
    const control = getControlById(controles, resultado.control_ultimo_id)
    const ultimoControl = controles[controles.length - 1] // META o último control

    // Si no se encuentra el control, retornar previsión vacía
    if (!control) {
      return {
        sector: null,
        tiempo: null,
        tiempoTotal: null,
        control: null,
        distancia: null,
        porcentaje: null,
        inicioDistancia: null,
        controlUltimo: null
      }
    }

    if (sectores && sectores.length && control) {
      let sector = null
      let controlFin = null
      let controlInicio = null
      let j
      for (j = 0; j < sectores.length; j++) {
        controlInicio = controles[0]
        if (sectores[j].inicio) {
          controlInicio = getControlById(controles, sectores[j].inicio)
        }
        controlFin = getControlById(controles, sectores[j].fin)
        // Ojito, non funciona ```a < b < c```
        if ((controlInicio ? controlInicio.distancia : 0) <= control.distancia && control.distancia <= controlFin.distancia) {
          sector = sectores[j]
          break
        }
      }
      let controlCalcular = controlFin
      if (controlPrevision) {
        if ((controlInicio ? controlInicio.distancia : 0) <= controlPrevision.distancia && controlPrevision.distancia <= controlFin.distancia) {
          controlCalcular = controlPrevision
        } else {
          return {
            sector: null,
            tiempo: null,
            tiempoTotal: null,
            control: null,
            distancia: null,
            porcentaje: null,
            inicioDistancia: null,
            // inicioTiempo: previsionInicioTiempo,
            controlUltimo: null
          }
        }
      }

      let tiempo = null
      let distanciaPrevision = null
      let porcentaje = 0
      let tiempo0 = 0
      if (sector) {
        const distancia = control.distancia - controlInicio.distancia

        // Calcular corrector para tiempo neto
        let tiempoInicioCorrector = 0;
        if (competicion.tipo === 'TIEMPONETO' && resultado.start) {
          tiempoInicioCorrector = resultado.start - (competicion.guntime || 0);
        }

        tiempo0 = parseInt(resultado['control_' + controlInicio.id + '_tiempo'], 10) - tiempoInicioCorrector
        const tiempo1 = parseInt(resultado['control_' + control.id + '_tiempo'], 10) - tiempoInicioCorrector

        if (distancia > 0 && !isNaN(tiempo0) && !isNaN(tiempo1) && tiempo1 > tiempo0) {
          const velBase = distancia / (tiempo1 - tiempo0)
          const aplicaCoef = !((controlInicio && controlInicio.tipo === 'SALIDA') || (controlInicio && controlInicio.distancia === 0))
          const coefRaw = (controlCalcular && controlCalcular.coeficiente_dificultad) ? controlCalcular.coeficiente_dificultad : 1.0
          const coeficiente = (aplicaCoef && velBase > 0) ? coefRaw : 1.0
          const vel = velBase / (coeficiente || 1.0)
          tiempo = (controlCalcular.distancia - controlInicio.distancia) / vel
          const ahora = competicion.fecha_inicio ? msFullAhora(competicion.fecha_inicio) : msAhora()
          // @todo: necesitamos o valor de start no resultado!
          // @fixme: Esto está ben ¿¿¿??? comprobar mais abaixo na versión sin controles...
          let tiempoReferencia = competicion.guntime
          if (competicion.tipo === 'TIEMPONETO') {
            if (resultado.start) {
              tiempoReferencia = resultado.start
            } else {
              tiempoReferencia = competicion.guntime
            }
          } else {
            if (resultado.guntime) {
              tiempoReferencia = resultado.guntime
            }
          }
          distanciaPrevision = vel * (ahora - tiempoReferencia - tiempo0)

          // Calcular porcentaje sobre distancia TOTAL de la carrera
          const distanciaAbsolutaActual = controlInicio.distancia + distanciaPrevision

          if (control.tipo === 'META') {
            porcentaje = 100
          } else {
            // Porcentaje sobre la distancia total de la carrera
            porcentaje = (distanciaAbsolutaActual / ultimoControl.distancia) * 100
          }
        }
      }

      if (porcentaje > 100) {
        porcentaje = 100
        distanciaPrevision = controlCalcular.distancia - controlInicio.distancia
      }
      if (distanciaPrevision < 0) {
        porcentaje = 0
        distanciaPrevision = 0
      }

      return {
        sector: sector,
        sector_idx: j,
        tiempo: tiempo, // tiempo del sector
        tiempoTotal: parseInt(tiempo, 0) + parseInt(tiempo0, 10), // tiempo total de carrera
        control: controlCalcular,
        distancia: distanciaPrevision,
        porcentaje: porcentaje,
        inicioDistancia: controlInicio.distancia,
        // inicioTiempo: null,
        controlUltimo: control
      }
    } else {
      let previsionTiempo = null
      let previsionDistancia = null
      let previsionPorcentaje = null
      let previsionInicioTiempo = 0
      let previsionInicioDistancia = 0

      // Object.keys(resultado).forEach(key => {
      //   if (key.startsWith('control_')) {
      //     console.log(`${key}: ${resultado[key]}`)
      //   }
      // })

      // Calcular corrector para tiempo neto
      let tiempoInicioCorrector = 0;
      if (competicion.tipo === 'TIEMPONETO' && resultado.start) {
        tiempoInicioCorrector = resultado.start - (competicion.guntime || 0);
      }

      if (control) {
        if (competicion.prevision_control_iniciar) {
          const inicioPrevision = getControlById(controles, competicion.prevision_control_iniciar)
          previsionInicioTiempo = parseInt(
            resultado['control_' + inicioPrevision.id + '_tiempo'],
            10
          ) - tiempoInicioCorrector
          previsionInicioDistancia = inicioPrevision.distancia
        } else {
          // SIEMPRE usar el control actual como punto de inicio para la previsión
          previsionInicioTiempo = parseInt(resultado['control_' + control.id + '_tiempo'], 10) - tiempoInicioCorrector
          previsionInicioDistancia = control.distancia
        }

        if (controlPrevision === null || (typeof controlPrevision) === 'undefined') {
          // si no especificamos un control donde calcular la previsión,
          // lo haremos del último con previsión de marca (será seguramente meta).
          // Comprobamos si alguno de los controles siguientes tiene previsión de marca.
          // Si hay alguno seleccionamos el último
          let _controlPrevision = controles.filter((c) => {
            return c.prevision && c.distancia > control.distancia
          })
          controlPrevision = _controlPrevision[_controlPrevision.length - 1]
        }

        // Si el control de previsión es el mismo que el control actual, no calcular
        if (controlPrevision && controlPrevision.id === control.id) {
          controlPrevision = null
        }
        if (controlPrevision && controlPrevision.prevision) {
          // Buscar el control ANTERIOR al actual para calcular la velocidad
          let controlAnteriorParaVelocidad = null
          for (let i = 0; i < controles.length; i++) {
            if (controles[i].distancia >= control.distancia) break
            const tiempoEnControl = resultado['control_' + controles[i].id + '_tiempo']
            if (tiempoEnControl && controles[i].tipo !== 'SALIDA') {
              controlAnteriorParaVelocidad = controles[i]
            }
          }

          let distanciaEntreControles
          let tiempoEntreControles

          if (controlAnteriorParaVelocidad) {
            // Calcular velocidad entre el control anterior y el actual
            const tiempoControlAnterior = parseInt(resultado['control_' + controlAnteriorParaVelocidad.id + '_tiempo'], 10) - tiempoInicioCorrector
            const tiempoControlActual = parseInt(resultado['control_' + control.id + '_tiempo'], 10) - tiempoInicioCorrector

            distanciaEntreControles = control.distancia - controlAnteriorParaVelocidad.distancia
            tiempoEntreControles = tiempoControlActual - tiempoControlAnterior
          } else {
            // Si no hay control anterior, usar desde el inicio (guntime/start) hasta el control actual
            const tiempoControlActual = parseInt(resultado['control_' + control.id + '_tiempo'], 10) - tiempoInicioCorrector
            distanciaEntreControles = control.distancia
            tiempoEntreControles = tiempoControlActual
          }

          let v
          if (distanciaEntreControles > 0 && tiempoEntreControles > 0) {
            const vBase = distanciaEntreControles / tiempoEntreControles

            // Aplicar coeficiente del control de destino (donde queremos calcular la previsión)
            const coefRaw = (controlPrevision && controlPrevision.coeficiente_dificultad) ? controlPrevision.coeficiente_dificultad : 1.0

            // Solo aplicar coeficiente si no estamos calculando desde la salida (distancia 0)
            const aplicaCoef = !(previsionInicioDistancia === 0)
            const coeficiente = (aplicaCoef && vBase > 0) ? coefRaw : 1.0

            v = vBase / coeficiente
          } else {
            v = 0
          }

          previsionTiempo = previsionInicioTiempo + (controlPrevision.distancia - previsionInicioDistancia) / v

          if (control.tipo === 'META') {
            previsionDistancia = control.distancia
            previsionPorcentaje = 100
          } else {
            // eslint-disable-next-line no-unused-vars
            let start = competicion.guntime
            if (competicion.tipo === 'TIEMPONETO') {
              if (resultado.start) {
                start = resultado.start
              } else {
                start = competicion.guntime
              }
            } else {
              if (resultado.guntime) {
                start = resultado.guntime
              }
              // Eliminar warning
              void start
            }

            if (competicion.fecha_inicio) {
              const ahoraMs = msFullAhora(competicion.fecha_inicio)
              let tiempoEnControl = resultado['control_' + control.id + '_tiempo']

              // El tiempo de referencia (inicio de carrera)
              let tiempoReferencia = competicion.guntime
              if (competicion.tipo === 'TIEMPONETO' && resultado.start) {
                tiempoReferencia = resultado.start
              }

              // CORRECCIÓN: Si tiempoEnControl es menor que tiempoReferencia, 
              // significa que es relativo al guntime, no absoluto
              if (tiempoEnControl < tiempoReferencia) {
                tiempoEnControl = parseInt(tiempoReferencia, 10) + parseInt(tiempoEnControl, 10)
              }

              // Tiempo transcurrido DESDE que pasó por el control hasta ahora
              const tiempoTranscurrido = ahoraMs - tiempoEnControl

              // Buscar el SIGUIENTE control (tenga datos o no)
              let siguienteControl = null
              for (let i = 0; i < controles.length; i++) {
                if (controles[i].distancia > control.distancia) {
                  siguienteControl = controles[i]
                  break
                }
              }

              // Calcular distancia proyectada
              previsionDistancia = control.distancia + v * tiempoTranscurrido

              // Si hay siguiente control Y no tiene datos, limitar a su distancia (pararse ahí)
              if (siguienteControl) {
                const tieneDatosSiguiente = resultado['control_' + siguienteControl.id + '_tiempo']

                if (!tieneDatosSiguiente && previsionDistancia > siguienteControl.distancia) {
                  previsionDistancia = siguienteControl.distancia
                }
              }

              // Asegurar que la previsión nunca esté DETRÁS del último control pasado
              if (control && control.distancia > 0) {
                if (previsionDistancia < control.distancia) {
                  previsionDistancia = control.distancia
                }
              }

              previsionPorcentaje = previsionDistancia / ultimoControl.distancia * 100
            } else {
              previsionDistancia = control.distancia + v * (msAhora() - resultado['control_' + control.id + '_tiempo'])
            }

            if (previsionDistancia > ultimoControl.distancia) {
              previsionDistancia = ultimoControl.distancia
              previsionPorcentaje = 100
            }
          }
        }
      }

      if (previsionDistancia === null) {
        if (competicion.mostrar_barra_progreso) {
          if (control) {
            previsionDistancia = control.distancia
            if (control.tipo === 'META') {
              previsionPorcentaje = 100
            } else {
              previsionPorcentaje = control.distancia / ultimoControl.distancia * 100
            }
          } else {
            previsionDistancia = 0
            previsionPorcentaje = 0
          }
        }
      }

      if (previsionDistancia < 0) {
        previsionPorcentaje = 0
        previsionDistancia = 0
      }
      return {
        sector: null,
        tiempo: previsionTiempo,
        tiempoTotal: previsionTiempo,
        control: controlPrevision,
        distancia: previsionDistancia,
        porcentaje: previsionPorcentaje,
        inicioDistancia: 0, // distancia ya es absoluta en esta rama (sin sectores)
        // inicioTiempo: previsionInicioTiempo,
        controlUltimo: control
      }
    }
  } catch (e) {
    console.trace(e)
    return {
      sector: null,
      tiempo: null,
      tiempoTotal: null,
      control: null,
      distancia: null,
      porcentaje: null,
      inicioDistancia: null,
      // inicioTiempo: previsionInicioTiempo,
      controlUltimo: null
    }
  }
}

export const calculateDiferencia = (resultados, dorsal, controlId, competicion) => {
  if (!Array.isArray(resultados) || resultados.length === 0) {
    return false;
  }

  // Calcular tiempo neto del primer puesto
  const primerResultado = resultados[0]
  let tiempoInicioCorrector1 = 0
  if (competicion && competicion.tipo === 'TIEMPONETO' && primerResultado.start) {
    tiempoInicioCorrector1 = primerResultado.start - (competicion.guntime || 0)
  }

  const tiempoAbsoluto1 = primerResultado['control_' + controlId + '_tiempo']
  const tiempoPrimerPuesto = tiempoAbsoluto1 ? (tiempoAbsoluto1 - tiempoInicioCorrector1) : null

  if (!tiempoPrimerPuesto) {
    return "-"
  }

  // Calcular tiempo neto del corredor actual
  let tiempoDorsalActual = null
  for (let i = 0; i < resultados.length; i++) {
    if (resultados[i].dorsal === dorsal) {
      let tiempoInicioCorrector2 = 0
      if (competicion && competicion.tipo === 'TIEMPONETO' && resultados[i].start) {
        tiempoInicioCorrector2 = resultados[i].start - (competicion.guntime || 0)
      }

      const tiempoAbsoluto2 = resultados[i]['control_' + controlId + '_tiempo']
      tiempoDorsalActual = tiempoAbsoluto2 ? (tiempoAbsoluto2 - tiempoInicioCorrector2) : null
      break
    }
  }

  if (!tiempoDorsalActual) {
    return "-"
  }

  const tiempoDiferencia = tiempoDorsalActual - tiempoPrimerPuesto

  if (tiempoDiferencia === 0) {
    return "-"
  }

  return "+ " + formatMs(tiempoDiferencia)
}